import React, { useState } from "react"
import addToMailchimp from "gatsby-plugin-mailchimp"
import { Alert, Button, Form } from "react-bootstrap"

const Newsletter = () => {
  const [email, setEmail] = useState("")
  const [name, setName] = useState("")
  const [submitResult, setSubmitResult] = useState({})

  const handleSubmit = async e => {
    e.preventDefault()
    const result = await addToMailchimp(email, { FNAME: name })
    // I recommend setting `result` to React state
    // but you can do whatever you want
    setSubmitResult(result)
    console.log(result)
  }

  return (
    <>
      <Form name="newsletter" method="post" onSubmit={handleSubmit}>
        <Form.Group controlId="validationName">
          <Form.Control
            type="text"
            placeholder="Votre prénom"
            name="name"
            label="Votre prénom"
            value={name}
            onChange={e => setName(e.target.value)}
          />
        </Form.Group>
        <Form.Group controlId="validationEmail">
          <Form.Control
            type="email"
            placeholder="Votre email"
            name="email"
            label="Votre email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
          />
        </Form.Group>
        {submitResult.result === "success" ? (
          <Alert variant="success">Inscription réussie&nbsp;!</Alert>
        ) : submitResult.result === "error" ? (
          <Alert variant="warning">
            Il y a une erreur, vous êtes peut-être déjà inscrit(e) à la liste
            d'abonnés.
          </Alert>
        ) : (
          <Button variant="primary" type="submit">
            Je m'inscris
          </Button>
        )}
      </Form>
    </>
  )
}

export default Newsletter
